import { ChatWidgetSettings } from 'components/settings/components/sections/chat/chatWidgetSettings';
export const SettingsChatSetupView = ChatWidgetSettings;
